import * as Joi from "joi";
import { Moment } from 'moment';
import {
	Column,
	Entity,
	JoinColumn,
	ManyToOne,
	OneToOne,
	PrimaryGeneratedColumn,
} from 'typeorm';
import { booleanTransformer, GenPartial, momentTransformer } from 'typeormgen';
import { COLORS } from '../enums/enums';
import EpisodicCharacter from '../episodic-characters/episodic-character.entity';
import PictureRelation from '../picture-relations/picture-relation.entity';
import Picture from '../pictures/picture.entity';

@Entity('episodic_character_pictures')
export default class EpisodicCharacterPicture extends PictureRelation {
	static tableName = 'episodic_character_pictures';

	@PrimaryGeneratedColumn()
	id: number;

	@Column('int')
	episodic_id: number;

	@Column('int')
	episodic_character_id: number;

	@Column('int')
	picture_id: number;

	@Column({ type: 'timestamp', transformer: momentTransformer })
	last_updated_time: Moment;

	@Column('int')
	last_updated_user: number;

	@Column('int')
	created_by: number;

	@Column({ type: 'timestamp', transformer: momentTransformer })
	date_created: Moment;

	@ManyToOne(
		(type) => EpisodicCharacter,
		(episodicCharacter) => episodicCharacter.episodicCharacterPictures
	)
	@JoinColumn({
		name: 'episodic_character_id',
	})
	episodicCharacter: EpisodicCharacter;

	@Column({ type: 'tinyint', transformer: booleanTransformer })
	main_photo: boolean;

	@OneToOne((type) => Picture, (picture) => picture.episodicCharacterPicture)
	@JoinColumn({
		name: 'picture_id',
	})
	picture: Picture;

	department: number;

	static rules() {
		return {
			...PictureRelation.rules(),
			created_by: Joi.number().integer(),
			date_created: Joi.date().allow(null),
			id: Joi.number().integer(),
			last_updated_time: Joi.date().allow(null),
			last_updated_user: Joi.number().integer(),
			episodic_id: Joi.number().integer(),
			episodic_character_id: Joi.number().integer(),
			picture_id: Joi.number().integer(),
			main_photo: Joi.boolean(),
		};
	}

	toJSON() {
		return {
			...super.toJSON(),
			created_by: this.created_by,
			date_created: this.date_created,
			id: this.id,
			last_updated_time: this.last_updated_time,
			last_updated_user: this.last_updated_user,
			episodic_id: this.episodic_id,
			episodic_character_id: this.episodic_character_id,
			picture_id: this.picture_id,
			department: this.picture ? this.picture.department : null,
			main_photo: this.main_photo,
		};
	}

	assign(props?: GenPartial<EpisodicCharacterPicture>) {
		super.assign(props);

		if (props) {
			if (typeof props.last_updated_time !== 'undefined') {
				this.last_updated_time = momentTransformer.from(
					props.last_updated_time
				);
			}
			if (typeof props.date_created !== 'undefined') {
				this.date_created = momentTransformer.from(props.date_created);
			}
		}
	}

	constructor(props?: GenPartial<EpisodicCharacterPicture>) {
		super(props);
	}

	getTagColor() {
		return COLORS.CHARACTERS_LIGHT;
	}

	getTagRemoveColor() {
		return COLORS.CHARACTERS;
	}
}
